import React from "react";
import { Container, Row, Col } from "shards-react";
import { withRouter } from "react-router";

import ViewReport from "../components/report/ViewReport";

class Report extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <Container fluid className="main-content-container px-4">
        <Row className="py-3">
          <Col lg="12">
            <ViewReport
             projectId={this.props.match.params.id}
             viewProps={this.props}
             />
          </Col>
        </Row>
      </Container>
    );
  }
}

export default withRouter(Report);
